import dataTableReducer from "@/features/dataTableSlice";
import systemReducer from "@/features/systemSlice";
import userReducer from "@/features/userSlice";
import { configureStore } from "@reduxjs/toolkit";

import commissionReducer from "@/features/commissionSlice";
import dailyManageReducer from "@/features/dailyManageSlice";
import giveAwayManageReducer from "@/features/giveAwayManageSlice";
import productSalesReducer from "@/features/productSalesSlice";
import workLocationManageReducer from "@/features/workLocationManageSlice";

export default configureStore({
  reducer: {
    workLocationManage: workLocationManageReducer,
    commission: commissionReducer,
    user: userReducer,
    system: systemReducer,
    giveAwayManage: giveAwayManageReducer,
    daily: dailyManageReducer,
    dataTable: dataTableReducer,
    productSales: productSalesReducer,
  },
});
